import { Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/material';

import DeleteIcon from '~/assets/icons/svgs/trash-bin.svg?react';
import PDFPreviewIcon from '~/components/ui/PDFPreviewIcon';
import { Text } from '~/components/ui/text';
import { COLORS } from '~/styles/colors';

export const UploadedImagePreview = ({ imageName, deleteHandler, imageSize, id, isLoading, imgSrc, isPDF }) => {
  return (
    <Box
      sx={{
        boxShadow: 'none',
        padding: '12px 16px',
        marginTop: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: COLORS.lightGray,
        border: `1px solid ${COLORS.grey200}`,
        borderRadius: '16px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {isPDF ? <PDFPreviewIcon /> : <StyledImage src={imgSrc} alt={id} />}
        <div>
          <Text variant="t16Regular" sx={{ wordBreak: 'break-word' }}>
            {imageName}
          </Text>
          <Text variant="inputSmall" sx={{ color: COLORS.grey400 }}>
            {imageSize}
          </Text>
        </div>
      </Box>
      <Box display="flex" alignItems="center">
        <StyledDeleteIcon onClick={() => deleteHandler(id)} />
        {isLoading && <CircularProgress size={25} sx={{ ml: 1 }} />}
      </Box>
    </Box>
  );
};

const StyledDeleteIcon = styled(DeleteIcon)(() => {
  return {
    cursor: 'pointer',
  };
});

const StyledImage = styled('img')(() => {
  return {
    width: '42px',
    height: '42px',
    objectFit: 'cover',
    borderRadius: '8px',
  };
});
